import Vue from 'vue'
import { Select, Option, OptionGroup } from 'element-ui'
import 'element-ui/lib/theme-chalk/select.css'
import 'element-ui/lib/theme-chalk/option.css'
import 'element-ui/lib/theme-chalk/option-group.css'
import 'element-ui/lib/theme-chalk/base.css'

Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)